<template>
    <div class="list-filter ~box">
        <div class="list-filter__item card"
        v-for="(item, index) in sections"
        :key="index"
        @click="filter(index)">
            <div class="list-filter__item_name">{{item.name}}</div>
            <img class="list-filter__item_icon" :src="require(`@/assets/icons/${item.icon}.svg`)"/>
            <div class="list-filter__item_filtered" v-if="item.filtered"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filters'],
        data () {
            return {
                sections: [
                    {name: '位置', icon: 'map-sharp-light', filtered: false, value: ['region', 'stations']},
                    {name: '预算', icon: 'tags-sharp-thin', filtered: false, value: ['cost1', 'cost2']},
                    {name: '户型', icon: 'table-layout-sharp-thin', filtered: false, value: ['layout']}
                ]
            }
        },
        methods: {
            filter (i) {
                this.$emit('filter', {index: i})
            }
        },
        watch: {
            'filters': {
                deep: true,
                handler: function () {
                    const that = this
                    for (let i=0; i < this.sections.length; i++) {
                        let filtered = false
                        for (let j=0; j < that.sections[i].value.length; j++) {
                            const prop = that.sections[i].value[j]
                            // console.info(prop, that.filters[prop])
                            if (that.filters[prop] != undefined && that.filters[prop] != '') filtered = true
                        }
                        that.sections[i].filtered = filtered
                    }
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .list-filter {
        display: flex;
        align-items: center;
        background-color: #fff;
        .list-filter__item_filtered {
            background-color: #08979C;
            width: 6px;
            height: 6px;
            border-radius: 100%;
            position: absolute;
            right: 20px;
            top: 10px;
        }
        .list-filter__item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            padding: 10px 0;
            margin-right: 10px;
            box-sizing: border-box;
            position: relative;
            &:last-child {
                margin-right: 0;
            }
            .list-filter__item_icon {
                width: 16px;
                height: 15px;
                margin-left: 15px;
            }
            .list-filter__item_name {
                text-align: center;
                font-size: 10pt;
                color: #333;
            }
        }
    }
</style>

